import React, { useEffect, useState } from 'react'
import './ConsultantRatings.scss';
import { useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { format } from 'date-fns';
import moment from 'moment';
import styled from '@emotion/styled';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import Toolbar from '@mui/material/Toolbar';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import { CircularProgress } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import TableSortLabel from '@mui/material/TableSortLabel';
import calendarIcon from '../../../assets/images/CommonComponent/calendarIcon.png';
import { Label} from "reactstrap";
import { useSelector, useDispatch } from 'react-redux';
import {stableSort, rowOptions, downloadExcel, parseJSON, getComparator} from '../../../utils/Helper'
import { downloadConsultantRatingsExcel, getConsultantRatings } from '../../../redux/actions/ReportAction/ConsultantRatingAction/ConsultantRatingAction';
import DownloadButton from '../../../components/Button/DownloadButton';
import DatePicker from '../../../components/DatePicker/DatePicker';
import { tabKeys } from '../../../Config/Constant';


const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))

const headCells = [
    {
        id: 'support_staff_name',
        disablePadding: false,
        label: 'CONSULTANT / THERAPIST',
        width: '20%'
    }, 
    {
        id: 'session_count',
        disablePadding: false,
        label: 'TOTAL SESSION',
        width: '10%'
    },
    {
        id: 'total',
        disablePadding: false,
        label: 'TOTAL RATING',
        width: '10%'
    },
    {
        id: 'D',
        disablePadding: false,
        label: 'D',
        width: '8.5%'
    },
    {
        id: 'percent_D',
        disablePadding: false,
        label: '%',
        width: '8.5%'
    },
    {
        id: 'N',
        disablePadding: false,
        label: 'N',
        width: '8.5%'
    },
    {
        id: 'percent_N',
        disablePadding: false,
        label: '%',
        width: '8.5%'
    },
    {
        id: 'P',
        disablePadding: false,
        label: 'P',
        width: '8.5%'
    },
    {
        id: 'percent_P',
        disablePadding: false,
        label: '%',
        width: '8.5%'
    },
    {
        id: 'percent_score',
        disablePadding: false,
        label: 'QMS Score',
        width: '8.5%'
    }
];

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) =>
                (<TableCell
                    key={headCell.id}
                    align='left'
                    width={headCell.width}
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                >
                    <TableSortLabel
                        
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        hideSortIcon={headCell.id === 'action' ? true : false}
                    >
                        <div style={{textAlign: "left"}}>
                            {headCell.label}
                        </div>
                        {orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>)
                )}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { activeTab, setShowLoader } = props;
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [fromDate, setFromDate] = useState(searchParams.get('filter_from') || format(new Date(), "yyyy-MM-01"));
    const [toDate, setToDate] = useState(searchParams.get('filter_to') || format(new Date(), "yyyy-MM-dd"));
    const {downloadLoader} = useSelector(state => state?.consultantRatings);

    useEffect(() => {
        if (activeTab == tabKeys.reports.CONSULTANT_RATINGS) {
            setFromDate(searchParams.get('filter_from') || format(new Date(), "yyyy-MM-01"));
            setToDate(searchParams.get('filter_to') || format(new Date(), "yyyy-MM-dd"));
        }
    }, [activeTab, searchParams]);


    const changeFromDate = (val) => {
        setShowLoader(true)
        const formattedDate = format(val, "yyyy-MM-dd");
        setFromDate(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate && formattedDate !== format(new Date(), "yyyy-MM-01")) {
            newParams.set('filter_from', formattedDate);
        } else {
            newParams.delete('filter_from');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }

    const changeToDate = (val) => {
        setShowLoader(true)
        const formattedDate = format(val, "yyyy-MM-dd");
        setToDate(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate && formattedDate !== format(new Date(), "yyyy-MM-dd")) {
            newParams.set('filter_to', formattedDate);
        } else {
            newParams.delete('filter_to');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }

    const downloadTableData = ()=>{
        let d = parseJSON(localStorage.getItem('filtersReport')) || {}
        const onSuccessCallback = (data)=>{
            downloadExcel({data, fileName:  `Consultant Ratings Report - ${format(new Date(fromDate), 'dd-MM-yyyy')} to ${format(new Date(toDate), 'dd-MM-yyyy')}.xlsx`})
        }

        dispatch(downloadConsultantRatingsExcel({
            ...d,
            "filter_from": searchParams.get('filter_from') || fromDate,
            "filter_to": searchParams.get('filter_to') || toDate,
            onSuccessCallback
        }))
    }

    return (
        <>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 },

            }}
            >
                <div className='w-100 d-flex justify-content-between align-items-center'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Consultant Ratings
                    </MainHeading>
                </div>
                <div className='d-flex align-items-center'>
                    <div className='DurationDiv d-flex align-items-center'>
                        <Label className='font-weight-bold mr-2'>Date:</Label>
                    <DatePicker
                        onChange={date => { changeFromDate(date) }}
                        showMonthDropdown={true}
                        showYearDropdown={true}
                        value={new Date(moment(fromDate, "YYYY-MM-DD").format('MM-DD-YYYY'))}
                        maxDate={new Date()}
                        popperPlacement={"bottom"}
                        width={'140px'}
                        height={'48px'}
                    />
                    <div className='mx-2'>to</div>
                    <DatePicker
                        onChange={date => { changeToDate(date) }}
                        showMonthDropdown={true}
                        showYearDropdown={true}
                        value={new Date(moment(toDate, "YYYY-MM-DD").format('MM-DD-YYYY'))}
                        minDate={new Date((moment(fromDate, "YYYY-MM-DD").add(1, 'days')).format('MM-DD-YYYY'))}
                        maxDate={new Date()}
                        popperPlacement={"bottom"}
                        width={'140px'}
                        height={'48px'}
                    />
                    </div>
                    <div className="separator"></div>
                    <DownloadButton
                        loading={downloadLoader}
                        disabled={downloadLoader}
                        text={'Download Excel'}
                        onClick={downloadTableData}
                    />
                </div>
            </Toolbar>
            <Divider />
        </>
    );
}

const ConsultantRatingsTable = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [order, setOrder] = useState(searchParams.get('order_by_type') || 'asc');
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') || 'name');
    const [selected, setSelected] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('limit')) || 10);
    const [viewConsultantRatings, setViewConsultantRatings] = useState('');
    const viewConsultantRatingsList = useSelector(state => state?.consultantRatings);
    const viewConsultantRatingsListDataRes = useSelector(state => state?.consultantRatings?.consultantRatings);
    const { activeTab } = props;
    const dispatch = useDispatch();



    useEffect(() => {
        if (activeTab == tabKeys.reports.CONSULTANT_RATINGS) {
            const sendRequest = {
                "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('limit') || 10,
                "filter_from": searchParams.get('filter_from') || format(new Date(), "yyyy-MM-01"),
                "filter_to": searchParams.get('filter_to') || (format(new Date(), "yyyy-MM-dd") === format(new Date(), "yyyy-MM-01") ? '' : format(new Date(), "yyyy-MM-dd")),
                "order": searchParams.get('order_by_type') || '',
                "orderBy": searchParams.get('order_by') || ''
            };
            dispatch(getConsultantRatings(sendRequest));
        }else{
          setOrder('');
          setOrderBy('');
          setRowsPerPage(10)
        }
    }, [activeTab, searchParams]);
    
    useEffect(() => {
        if (viewConsultantRatingsList.error !== "Ananda consultantRatings data does not exists") {
            setViewConsultantRatings(viewConsultantRatingsListDataRes && viewConsultantRatingsListDataRes);
        } else {
            setViewConsultantRatings('');
        }

    }, [viewConsultantRatingsListDataRes, viewConsultantRatingsList])

    useEffect(()=>{
            if(!viewConsultantRatingsList.loading)
                setShowLoader(false)
            if(!viewConsultantRatingsList.loading && !viewConsultantRatingsListDataRes.length && !viewConsultantRatingsList.error){
                setShowLoader(true)
            }
        }, [viewConsultantRatingsList.loading])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('order_by_type', newOrder);
        newParams.set('order_by', property);
        setSearchParams(newParams, { replace: true });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = viewConsultantRatingsListDataRes && viewConsultantRatings.map((n) => n?.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    return (
        <div className="ProBox">
            <Box sx={{ width: '100%', height: 'calc(100vh - 200px)' }} className="ConsultantRatingsBox">
            <Paper sx={{ width: '100%', mb: 2, borderRadius: 2, height: '100%' }}>
                    <EnhancedTableToolbar 
                        setShowLoader={setShowLoader}
                        showLoader={viewConsultantRatingsList.loading}
                        activeTab ={activeTab} />
                {
                    showLoader ?
                    <div className='w-100 text-center py-5'>
                        <CircularProgress sx={{'color': '#74613C'}}/>
                    </div>
                    :
                    <>
                        
                        {!!viewConsultantRatings?.length ? <TableContainer sx={{ maxHeight: 'calc(100% - 90px)' }}>
                            <Table
                                sx={{ minWidth: 750 }}
                                aria-labelledby="tableTitle"
                                stickyHeader
                                size='small'
                            >
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={handleSelectAllClick}
                                    onRequestSort={handleRequestSort}
                                    rowCount={viewConsultantRatingsListDataRes && viewConsultantRatings?.length}
                                />
                                <TableBody>
                                    {
                                        viewConsultantRatingsListDataRes&&
                                        stableSort(viewConsultantRatings, getComparator(order, orderBy))
                                            // .slice((rowsPerPage * (page - 1)), (rowsPerPage * (page) + rowsPerPage))
                                            .map((row, index) => {
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return (
                                                    <React.Fragment key={index}>
                                                        <TableRow hover onClick={(event) => handleClick(event, row.title)} role="checkbox"

                                                            tabIndex={-1}
                                                            key={index}

                                                            >
                                                            <TableCell align="left">{row.support_staff_name || '-'}</TableCell>
                                                            <TableCell align="left">{row.session_count || '0'}</TableCell>
                                                            <TableCell align="left">{row.total || '0'}</TableCell>
                                                            <TableCell align="left">{row.D || '0'}</TableCell>
                                                            <TableCell align="left">{row.percent_D || '0'}</TableCell>
                                                            <TableCell align="left">{row.N || '0'}</TableCell>
                                                            <TableCell align="left">{row.percent_N || '0'}</TableCell>
                                                            <TableCell align="left">{row.P || '0'}</TableCell>
                                                            <TableCell align="left">{row.percent_P || '0'}</TableCell>
                                                            <TableCell align="left">{row.percent_score || '0'}</TableCell>
                                                        </TableRow>
                                                        
                                                    </React.Fragment>
                                                );
                                            })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                         : <div className='text-center w-100 text-muted mt-3'>No Records</div>}
                    </>
                }
                </Paper>
                {/* {
                    viewConsultantRatings
                    &&
                    <div className='paginationBlock'>
                        <div className='textData'><p>Items per page: </p></div>
                        <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                            <Select
                                placeholder={rowsPerPage}
                                className="react-select"
                                classNamePrefix="react-select"
                                value={rowsPerPage}
                                options={rowOptions}
                                isSearchable={false}
                                onChange={handleChangeRowsPerPage}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: '#F5F5F5',
                                        primary: '#74613C',
                                    },
                                })}
                                menuPlacement="top"
                                menuPosition="fixed"
                                styles={{
                                    menu: (base) => ({
                                        ...base,
                                        top: 'auto',
                                        bottom: 0,
                                    }),
                                }}
                            />
                        </FormGroup>
                        {viewConsultantRatingsListDataRes?.data && <p className='endText'>   {viewConsultantRatingsListDataRes?.data?.start} - {viewConsultantRatingsListDataRes?.data?.end} of {viewConsultantRatingsListDataRes?.data?.total}</p>}
                        <p>
                            <button className={btnPrev.join(' ')} onClick={() => { handleChangePagePrev(page) }}>
                                <ArrowBackIosNewSharpIcon className='iconBtn' />
                            </button>
                            <button className={btnNext.join(' ')} onClick={() => { handleChangePageNext(page) }}>
                                <ArrowForwardIosSharpIcon className='iconBtn' />
                            </button></p>
                    </div>   
                } */}
            </Box>
        </div>
    );
}
export default ConsultantRatingsTable;